import { __awaiter } from "tslib";
import Vue from 'vue';
import { StepByStepGlossary } from '@/constants/services';
import { ActivePopupTypes } from '@whitelist/wl-old-library/components/global/types';
import { mapGetters } from 'vuex';
import { YubikeyAuthMixin } from '@/mixins/YubikeyAuthMixin';
export default Vue.extend({
    name: 'exitBuddy',
    mixins: [YubikeyAuthMixin],
    data: () => {
        return {
            errors: [],
            loading: false
        };
    },
    props: {
        slotData: {
            required: false
        }
    },
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    methods: {
        exitBuddyHandler(sessionId) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield this.services.buddy.unplugBuddy({ sessionId });
                if (response.status !== 200) {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('buddyPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: (_a = response.data.errors.join('\n')) !== null && _a !== void 0 ? _a : this.$t('buddyPage.failedToExitBuddy')
                    });
                    return;
                }
                this.slotData.updateBuddyStatusFn();
                this.$store.commit('popupModule/setClosed');
            });
        },
        exitBuddy() {
            return __awaiter(this, void 0, void 0, function* () {
                const context = this;
                try {
                    const sessionResponse = yield this.services.mainService.confirmSession({ sessionId: StepByStepGlossary.disconnectBuddy });
                    if (!sessionResponse.success)
                        throw new Error();
                    const sessionId = sessionResponse.data.session_id;
                    const { confirmations } = sessionResponse.data;
                    const confirmationType = context.getUserData.confirmation;
                    if (confirmationType === 'yubikey') {
                        const reInitExitBuddyYubikey = () => {
                            context.YubikeyAuth(StepByStepGlossary.disconnectBuddy, StepByStepGlossary.disconnectBuddy, (authResponse, sessionId) => __awaiter(this, void 0, void 0, function* () {
                                var _a;
                                if (!authResponse.success) {
                                    context.$store.commit('popupModule/setClosed');
                                    context.$store.dispatch('alertsBus/openAlert', {
                                        title: context.$t('buddyPage.alerts.titles.error'),
                                        type: 'error',
                                        autoDelete: true,
                                        content: (_a = authResponse.errors.join('\n')) !== null && _a !== void 0 ? _a : context.$t('buddyPage.failedToExitBuddy')
                                    });
                                    return;
                                }
                                context.exitBuddyHandler(sessionId);
                            }), null, reInitExitBuddyYubikey);
                        };
                        reInitExitBuddyYubikey();
                        return;
                    }
                    const isOperationRequiredSms = confirmationType === 'sms';
                    context.$store.dispatch('popupModule/openPopup', {
                        type: ActivePopupTypes.action,
                        letDefaultClose: true,
                        title: context.$t('buddyPage.popups.titles.buddyExit'),
                        content: isOperationRequiredSms ? '' : context.$t('popups.enterGACode'),
                        slot: {
                            name: isOperationRequiredSms ? 'commonConfirmSMSPopupChunk' : 'commonConfirmGAPopupChunk',
                            data: {
                                isLoading: false,
                                codes: confirmations,
                                sessionId,
                                responseErrors: []
                            },
                            on: {
                                onSubmit(payload) {
                                    return __awaiter(this, void 0, void 0, function* () {
                                        context.$store.commit('popupModule/setSlotData', { isLoading: true });
                                        const validateSessionResponse = yield context.services.mainService.validateSession({ payload: { [confirmationType]: payload[`code_${confirmationType}`] }, sessionId });
                                        if (!validateSessionResponse.success) {
                                            context.$store.commit('popupModule/setSlotData', { responseErrors: validateSessionResponse.data.errors, isLoading: false });
                                            return;
                                        }
                                        context.exitBuddyHandler(sessionId);
                                    });
                                },
                                onCancel() {
                                    context.$store.commit('popupModule/setClosed');
                                }
                            }
                        }
                    });
                }
                catch (e) {
                    console.error(e);
                    context.$store.dispatch('alertsBus/openAlert', {
                        title: 'Ошибка',
                        type: 'error',
                        autoDelete: true,
                        content: context.$t('buddyPage.failedToExitBuddy')
                    });
                }
            });
        }
    }
});
